module.exports = __webpack_public_path__ + "img/avatar5.0e1efda8.png";